import axios from 'axios';

const create = (config = {}) => {
  const service = axios.create(config);

  // Add a request interceptor
  service.interceptors.request.use(
    function(config) {
      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  );

  // Add a response interceptor
  service.interceptors.response.use(
    function(response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      if (response.data.code !== 0) {
        return Promise.reject(response.data);
      }
      return response.data;
    },
    function(error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      return Promise.reject(error);
    }
  );
  return service;
};

export default create;
